import { Injectable } from "@angular/core";
import { parse } from "cookie";

import { ENV } from "../../config/auth-config";

const SPOOF_USER_KEY = "RSS:SPOOF:USER";
@Injectable()
export class AuthService {
  constructor() {}

  getSpoofUser(): any {
    const spoofUser = parse(document.cookie)[SPOOF_USER_KEY];
    if (spoofUser) {
      return { userId: spoofUser };
    }

    return null;
  }

  redirectToIdp(): void {}

  hasImpersonateAccess = (authUser) =>
    ["local", "localhost", "development", "dev", "qa"].includes(ENV) &&
    authUser &&
    authUser.rss;
}



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/shared/service/auth.service.ts